import { render } from "./UIRegionsDropdown.vue?vue&type=template&id=013690da"
import script from "./UIRegionsDropdown.vue?vue&type=script&lang=js"
export * from "./UIRegionsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__